import styled from '@emotion/styled';
import Calendar from '@/components/atoms/Calendar';

export const StyledCalendar = styled(Calendar)`
    margin: ${({ theme }) => theme.spacing[4]} 0 ${({ theme }) => theme.spacing[6]};
`;

export const PresetDateButtonsContainer = styled.div`
    margin-top: ${({ theme }) => theme.spacing[4]};
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const ExportFormatContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    align-items: flex-end;
`;

export const ExportFormatSwitchesContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const ExportOptionsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[6]};
    margin-top: ${({ theme }) => theme.spacing[4]};
    align-items: flex-start;
`;

export const IncludeDeletedContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const IncludeDeletedLabel = styled.h2`
    font-size: ${({ theme }) => theme.font.size.medium};
    font-family: ${({ theme }) => theme.font.family};
    font-weight: ${({ theme }) => theme.font.weight.medium};
    color: ${({ theme }) => theme.color.black};
    white-space: nowrap;
    margin: 0;
    padding: 0;
    line-height: 1.2;
`;
